import { SegmentControl, SegmentItem } from '@lifebit-ai/lds'
import { ResultsType } from 'enums'
import React from 'react'

import { useExportAndAccessRequestsTab } from 'modules/requests/hooks/useExportAndAccessRequestsTab'
import { ExportAndAccessSubTabKeys } from 'modules/requests/requestsTabKeys'

import * as styles from './ExportAndAccessRequestsTab.styles'
import ExportAndAccessRequestsTable from './ExportAndAccessRequestsTable/ExportAndAccessRequestsTable'

export const ExportAndAccessRequestsTab = () => {
  const { activeSubTabKey, onSelectSubTab } = useExportAndAccessRequestsTab()

  return (
    <styles.Container>
      <SegmentControl activeKey={activeSubTabKey} onChange={onSelectSubTab} mode="equal">
        <SegmentItem segmentKey={ExportAndAccessSubTabKeys.Files} segmentName="Files / Folders" />
        <SegmentItem segmentKey={ExportAndAccessSubTabKeys.Analysis} segmentName="Analysis" />
      </SegmentControl>
      {activeSubTabKey === ExportAndAccessSubTabKeys.Files ? (
        <ExportAndAccessRequestsTable resultType={ResultsType.FilesFolders} />
      ) : null}
      {activeSubTabKey === ExportAndAccessSubTabKeys.Analysis ? (
        <ExportAndAccessRequestsTable resultType={ResultsType.Analysis} />
      ) : null}
    </styles.Container>
  )
}
